import { render, staticRenderFns } from "./tournamentsList.vue?vue&type=template&id=3f9b4c64&scoped=true&"
import script from "./tournamentsList.vue?vue&type=script&lang=js&"
export * from "./tournamentsList.vue?vue&type=script&lang=js&"
import style0 from "./tournamentsList.vue?vue&type=style&index=0&id=3f9b4c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b4c64",
  null
  
)

export default component.exports